export default __webpack_public_path__ + "static/media/sunwdokuz9.3b74bef5.jpg";